import { render } from "./employee_vacations_tab.vue?vue&type=template&id=45af0b10&scoped=true"
import script from "./employee_vacations_tab.vue?vue&type=script&lang=js"
export * from "./employee_vacations_tab.vue?vue&type=script&lang=js"

import "./employee_vacations_tab.vue?vue&type=style&index=0&id=45af0b10&lang=css"
import "./employee_vacations_tab.vue?vue&type=style&index=1&id=45af0b10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45af0b10"]])

export default __exports__